import { isUnsafeToLoseState, type SaveState } from './save-state';

/**
 * SPEC-007 §22/plan §12/T057 — pure classification so the guard's decision
 * table is unit-testable without a real router or browser event.
 */
export type NavigationDecision = 'allow' | 'flush' | 'prompt';

/**
 * clean/saved → navigate freely.
 * dirty/saving → attempt a flush first (P9: "dirty → flush", "saving → await/flush").
 * error/offline/conflict → nothing left to flush automatically; ask the user.
 */
export function decideNavigation(state: SaveState): NavigationDecision {
  if (!isUnsafeToLoseState(state)) return 'allow';
  if (state === 'dirty' || state === 'saving') return 'flush';
  return 'prompt';
}

export function shouldBlockUnload(state: SaveState): boolean {
  return isUnsafeToLoseState(state);
}
